<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <app-list-header [title]="'Preload List Data'" [$parent]="getSelf()">
      </app-list-header>

      <!-- Search Form -->
      <div class="col-md-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive mb-3">
                  <table id="dataTableId" class="table">
                    <thead class="table-light">
                      <tr>
                        <th>S.No.</th>
                        <th>List/Code</th>
                        <th>Parent</th>
                        <th>Value</th>
                        <th>Label</th>
                        <th>Status</th>
                        <th>Info</th>
                        <th align="right">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let e of form.list; let i = index">
                        <td>{{ pageIndex(i) }}</td>
                        <td>{{ e.listName }}</td>
                        <td>
                          <button title="View" class="btn btn-outline-primary btn-sm"
                            (click)="searchByField(e.fieldValue)">
                            <i class="lni lni-eye"></i>
                          </button>
                          {{ e.fieldValue }}
                        </td>
                        <td>{{ e.data }}</td>
                        <td>{{ e.label }}</td>
                        <td>{{ e.status == 1 ? "Active" : "Inactive" }}</td>
                        <td>
                          <app-info-button [ele]="e"></app-info-button>
                        </td>
                        <td>
                          <div class="d-flex order-actions">
                            <!--
                            <a class="btn btn-outline-success btn-sm" 
                              routerLink="/preloadlistdata/{{e.id}}">
                                <i class="fas fa-edit"></i> 
                            </a>
                             -->
                            <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal" (click)="get(e.id)">
                              <i class="fa fa-edit"></i>
                            </a>

                            <a title="Delete" class="ms-1" (click)="delete(e.id)">
                              <i class="fa fa-trash"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <app-list-header [$parent]="getSelf()"></app-list-header>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form -->
<div class="modal" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Preload List Data</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>
      <div class="modal-body">
        <form #uiForm="ngForm">
          <p>
            <form-error [form]="form"></form-error>
          </p>
          <div class="row mb-3">
            <label for="listId" class="col-sm-3 col-form-label"> List: </label>
            <div class="col-sm-9">
              <select required id="listId" name="listId" [(ngModel)]="form.data['listId']"
                class="form-select form-select-sm" (change)="getParentList(form.data['listId'])">
                <option [value]="'0'">--Select--</option>
                <option *ngFor="let e of form.preload['preloadList']" [value]="e.key">
                  {{ e.value }}
                </option>
              </select>
            </div>
          </div>

          <div *ngIf="form['parentList'] && form['parentList'].length > 0" class="form-group form-row">
            <label for="fieldId" class="col-sm-1 col-form-label col-form-label-sm">{{ form["parentName"] }}</label>
            <div class="col">
              <select required id="fieldId" name="fieldId" [(ngModel)]="form.data['fieldId']"
                class="form-select form-select-sm">
                <option [value]="'0'">--Select--</option>
                <option *ngFor="let e of form['parentList']" [value]="e.id">
                  {{ e.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-3">
            <label for="label" class="col-sm-3 col-form-label"> Label: </label>
            <div class="col-sm-9">
              <input [(ngModel)]="form.data['label']" id="label" name="label" placeholder="Enter Label" required
                type="text" class="form-control form-control-sm" />
            </div>
          </div>

          <div class="row mb-3">
            <label for="data" class="col-sm-3 col-form-label"> Value: </label>
            <div class="col-sm-9">
              <input required [(ngModel)]="form.data['data']" id="data" name="data" placeholder="Enter Data" type="text"
                class="form-control form-control-sm" />
            </div>
          </div>

          <div class="row mb-3">
            <label for="status" class="col-sm-3 col-form-label">
              Status:
            </label>
            <div class="col-sm-9">
              <select id="status" name="status" required [(ngModel)]="form.data['status']"
                class="form-select form-select-sm">
                <option *ngFor="let e of form.preload['statusList'] | keyvalue" [value]="e.value">
                  {{ e.key }}
                </option>
              </select>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm ml-2" [disabled]="!uiForm.valid" (click)="save()">
          <i class="fa fa-save"></i> Save
        </button>
        &nbsp;
        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="scrollableModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Search</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <label for="listId" class="col-sm-3 col-form-label">List</label>
          <div class="col-sm-9">
            <select class="form-select form-select-sm" id="listId" name="listId"
              [(ngModel)]="form.searchParams['listId']">
              <option selected>--Select--</option>
              <option *ngFor="let e of form.preload['preloadList'] | keyvalue" [value]="e.key">
                {{ e.value }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <label for="label" class="col-sm-3 col-form-label">Label:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm" id="label" name="label" placeholder="Enter Label"
                [(ngModel)]="form.searchParams['label']" />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label for="data" class="col-sm-3 col-form-label">Value:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm" id="data" name="data" placeholder="Enter Value"
                [(ngModel)]="form.searchParams['data']" />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <label for="status" class="col-sm-3 col-form-label">Status</label>
          <div class="col-sm-9">
            <select class="form-select form-select-sm" id="status" name="status"
              [(ngModel)]="form.searchParams['status']">
              <option selected>--Select--</option>
              <option *ngFor="let e of form.preload['statusList'] | keyvalue" [value]="e.value">
                {{ e.key }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <label for="fieldValue" class="col-sm-3 col-form-label">FieldValue:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm" id="fieldValue" name="fieldValue"
                placeholder="Enter FieldValue" [(ngModel)]="form.searchParams['fieldValue']" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2" title="Search"
          (click)="search()">
          Apply Filter
        </button>
        <button (click)="resetSearchForm()" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          title="Reset">
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
        <button type="button" title="Close" class="btn btn-outline-secondary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          data-bs-dismiss="modal">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>